import axios from 'axios';

const uri = process.env.REACT_APP_API_URL_SYNTH + process.env.REACT_APP_API_VERSION;


// URL endpoints

export function getSynthList() {
    return new Promise((resolve, reject) => {
        axios.get(uri + "list?previews=true")
            .then(function (response) {
                // handle success
                resolve(response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                reject(error);
            });
    });
}

/**
 * Uploads the synthPatch to the synthManager API which in turn
 * speaks with teh database and posts the file to s3
 * @param {Patch} synthPatch 
 */
export function uploadSynth(synthPatch) {
    return new Promise((resolve, reject) => {

        var formData = new FormData();

        // place the patch file data
        formData.append('patchFile', synthPatch.file);

        // convert synth data to string form
        let synthData = JSON.stringify({
            name: synthPatch.name,
            type: synthPatch.type,
            synthesizer: synthPatch.synthesizer
        });

        formData.set('patchInfo', synthData);

        axios({
            url: uri + "add",
            method: 'POST',
            responseType: 'application/json',
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            data: formData
        }).then(resolve)
            .catch(reject);
    });
}

export async function downloadSynth(patchID) {
    try {
        let patchURI = `${uri}demo/patch/${patchID}/download`;

        let s3DownloadURL = await axios({
            url: patchURI,
            method: 'GET',
            responseType: 'json',
            headers: {
                access_token: 'letmein',
                id_token: 'letmein'
            }
        });

        s3DownloadURL = s3DownloadURL.data;

        // hack to check if the file exists first. Highly inefficient
        // TODO make it load the file from the response
        await axios({
            url: s3DownloadURL,
            method: 'GET',
        });

        const link = document.createElement('a');
        link.href = s3DownloadURL;

        document.body.appendChild(link);

        // trigger download
        link.click();

        // clean up download tag
        document.body.removeChild(link);

        return s3DownloadURL;

    } catch (e) {
        console.log('An error occurred while getting the patch.', e);
        throw e;
    }

}


export async function downloadDemoSynth() {
    try {

        let s3DownloadURL = "https://mazino-media-assets.s3.eu-west-2.amazonaws.com/pluck_goodbye_to_a_world.fxp"

        const link = document.createElement('a');
        link.href = s3DownloadURL;

        document.body.appendChild(link);

        // trigger download
        link.click();

        // clean up download tag
        document.body.removeChild(link);

        return s3DownloadURL;

    } catch (e) {
        console.log('An error occurred while getting the patch.', e);
        throw e;
    }

}

export function getSynthCityStats() {
    return new Promise((resolve, reject) => {
        axios({
            url: uri + "stats",
            method: 'GET',
            responseType: 'application/json',
        }).then(res => resolve(res.data))
            .catch(err => {
                console.log("yikes couldn't get the data from the server")
                reject(err)
            })
    });
}


// WEBPACK FOOTER //
// ./src/components/synthcity/service/synthwsao.js